// ============================================================================
// FightModeToggle - Toggle button for fight mode
// ============================================================================

import { tv } from 'tailwind-variants';
import { isFightModeEnabled, toggleFightMode } from '../../state/combat';
import { hasPawnSelection } from '../../state/selection';

const fightModeToggle = tv({
  slots: {
    root: [
      'fixed bottom-4 left-1/2 -translate-x-1/2 z-[900]',
      'flex items-center gap-3',
      'bg-gradient-to-b from-slate-900/95 to-slate-900/85',
      'border border-game-border',
      'rounded-lg',
      'px-4 py-2.5',
      'shadow-game',
    ],
    modeButton: [
      'flex items-center gap-2 px-4 py-2',
      'rounded-md',
      'text-sm font-semibold',
      'transition-all duration-150',
      'cursor-pointer',
      'border',
    ],
    fightModeOff: [
      'bg-slate-800/60',
      'border-slate-600/40',
      'text-slate-400',
      'hover:bg-slate-700/60',
      'hover:border-slate-500/50',
    ],
    fightModeOn: [
      'bg-gradient-to-b from-red-700 to-red-900',
      'border-red-500/60',
      'text-red-100',
      'hover:from-red-600 hover:to-red-800',
      'shadow-[0_0_12px_rgba(220,38,38,0.3)]',
    ],
    shortcut: 'text-[10px] text-slate-500 ml-2 px-1.5 py-0.5 bg-slate-800 rounded',
  },
});

// Sword icon
const SwordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5" aria-hidden="true">
    <path d="M6.92 5L5 7l4.5 4.5L7 14l1.5 1.5 2.5-2.5 4.5 4.5 2-1.92L5 3zm10.16 0L20 8l-3 3 3 3-2.08 2.08L13.5 11.5 11 14l-1.5-1.5 2.5-2.5-4.5-4.5L9.58 3 17.08 5z" />
  </svg>
);

export const FightModeToggle = () => {
  const styles = fightModeToggle();

  // Only show if pawns are selected
  if (!hasPawnSelection.value) {
    return null;
  }

  const fightMode = isFightModeEnabled.value;

  const handleFightModeToggle = () => {
    toggleFightMode();
  };

  return (
    <div class={styles.root()}>
      {/* Fight Mode Toggle */}
      <button
        type="button"
        class={`${styles.modeButton()} ${fightMode ? styles.fightModeOn() : styles.fightModeOff()}`}
        onClick={handleFightModeToggle}
        title="Toggle fight mode - when enabled, right-click attacks targets"
      >
        <SwordIcon />
        <span>{fightMode ? 'Fight Mode' : 'Work Mode'}</span>
        <span class={styles.shortcut()}>F</span>
      </button>
    </div>
  );
};
